import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BannersState, PAYMENT_BANNER, TABLE, TableSort } from './bannersTypes';

const defaultSort: TableSort = {
    column: '',
    direction: 'desc',
    isSorted: false,
};

const initialState: BannersState = {
    paymentBanners: {
        [PAYMENT_BANNER.EXPIRED]: true,
        [PAYMENT_BANNER.FAILED]: true,
        [PAYMENT_BANNER.PAID]: true,
    },
    tableSorts: {
        [TABLE.JOURNAL_OVERVIEW_CONCLUDED_TRADES]: { ...defaultSort },
        [TABLE.JOURNAL_OVERVIEW_OPEN_TRADES]: { ...defaultSort },
        [TABLE.TRADE_HISTORY]: { ...defaultSort },
        [TABLE.ACCOUNT_OPEN_POSITIONS]: { ...defaultSort },
        [TABLE.ACCOUNT_WITHDRAWALS]: { ...defaultSort },
        [TABLE.HOME_BALANCES]: { ...defaultSort },
        [TABLE.HOME_OPEN_POSITIONS]: { ...defaultSort },
        [TABLE.VERIFICATION_PAGES]: { ...defaultSort },
    },
    pullBanners: {},
};

const slice = createSlice({
    name: 'banners',
    initialState,
    reducers: {
        resetBanners: (state) => {
            state.paymentBanners = {
                [PAYMENT_BANNER.EXPIRED]: true,
                [PAYMENT_BANNER.FAILED]: true,
                [PAYMENT_BANNER.PAID]: true,
            };
            state.tableSorts = {
                [TABLE.JOURNAL_OVERVIEW_CONCLUDED_TRADES]: { ...defaultSort },
                [TABLE.JOURNAL_OVERVIEW_OPEN_TRADES]: { ...defaultSort },
                [TABLE.TRADE_HISTORY]: { ...defaultSort },
                [TABLE.ACCOUNT_OPEN_POSITIONS]: { ...defaultSort },
                [TABLE.ACCOUNT_WITHDRAWALS]: { ...defaultSort },
                [TABLE.HOME_BALANCES]: { ...defaultSort },
                [TABLE.HOME_OPEN_POSITIONS]: { ...defaultSort },
                [TABLE.VERIFICATION_PAGES]: { ...defaultSort },
            };
            state.pullBanners = {};
        },
        setTableSort: (state, action: PayloadAction<{ tableName: TABLE; data: TableSort }>) => {
            const { tableName, data } = action.payload;
            state.tableSorts = {
                ...state.tableSorts,
                [tableName]: data,
            };
        },
        updatePullBanner: (
            state,
            action: PayloadAction<{ accountId: number; visible: boolean }>,
        ) => {
            const { accountId, visible } = action.payload;
            state.pullBanners = {
                ...state.pullBanners,
                [accountId]: visible,
            };
        },
        removeBannerByApiKey: (state, action: PayloadAction<{ apiKeyId: number }>) => {
            const { apiKeyId } = action.payload;
            if (state.pullBanners.hasOwnProperty(apiKeyId)) {
                delete state.pullBanners[apiKeyId];
            }
        },
    },
});

export const { resetBanners, setTableSort, updatePullBanner, removeBannerByApiKey } = slice.actions;

export default slice.reducer;
